// extracted by mini-css-extract-plugin
export default {"dataGrid":"LogsTableLine_dataGrid__Vv4kP","tileTitle":"LogsTableLine_tileTitle__uoyyX"};